import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, appConfig).catch((error: unknown) => {
  // Bootstrap failures happen before the error handler exists.
  // eslint-disable-next-line no-console
  console.error('Application failed to start', error);
});
